export default {
  style: 0,
  mask: '0'
};